export const name = "Label";

export const importDocs = `
import { Label } from "/components/ui/label"
`;

export const usageDocs = `
<Label htmlFor="email">Your email address</Label>
`;
